module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "pages-reviews"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('div', {
    staticClass: "pages-reviews__header",
    style: ({
      backgroundImage: 'url(' + _vm.props.reviews_banner + ')'
    })
  }), _c('BlockTitle', {
    attrs: {
      "props": _vm.props.block_title
    }
  }), _c('CustomReviewsContent', {
    attrs: {
      "props": _vm.props.review_links
    }
  }), _c('div', {
    staticClass: "pages-reviews__wrap"
  }, [_c('div', {
    staticClass: "pages-reviews__container"
  }, [_vm._m(0), _c('div', {
    staticClass: "pages-reviews__slider"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 3,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#006f51",
      "paginationColor": "#000",
      "paginationSize": 12,
      "perPageCustom": [
        [350, 1],
        [650, 2],
        [1024, 3]
      ]
    }
  }, _vm._l((_vm.props.reviews_list), function(slide, i) {
    return _c('Slide', {
      key: i
    }, [_c('div', {
      staticClass: "pages-reviews__slide"
    }, [_c('span', {
      staticClass: "pages-reviews__ratingwrap"
    }, [_c('Icon', {
      staticClass: "pages-reviews__googleicon",
      attrs: {
        "name": "google-circle"
      }
    }), _c('span', {
      staticClass: "pages-reviews__rating"
    }, [_vm._v("5.0 ")]), _vm._l((5), function(n) {
      return _c('Icon', {
        key: n,
        staticClass: "pages-reviews__star",
        attrs: {
          "name": "star"
        }
      })
    })], 2), _c('div', {
      staticClass: "pages-reviews__author",
      domProps: {
        "innerHTML": _vm._s(slide.author)
      }
    }), _c('div', {
      staticClass: "pages-reviews__text",
      domProps: {
        "innerHTML": _vm._s(slide.description)
      }
    })])])
  }))], 1)])])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-reviews__iframe"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "400px",
      "src": "https://www.youtube.com/embed/HKLWS3Eh2jA?si=2Jsq0hvpnwVrF0Rw",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8e42f88","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/reviews/reviews.pug
// module id = 666
// module chunks = 1